import React from 'react';
import '../../../index.css';

const CompanyInfoCards = () => {
  const values = [
    { title: 'Calidad', description: 'Cumplimiento de los requisitos y expectativas de nuestros clientes.' },
    { title: 'Responsabilidad', description: 'La ejecución del trabajo depende de cada uno de los elementos que conforman Maderas Estufadas del Guadiana.' },
    { title: 'Liderazgo', description: 'El ideal de que el trabajo se realice de manera correcta y eficiente.' },
    { title: 'Honestidad', description: 'Siempre con transparencia y una comunicación adecuada con los clientes y partes interesadas.' },
    { title: 'Compromiso', description: 'Realizar los proyectos con el mejor ímpetu y rendimiento de los elementos que conforman Maderas Estufadas del Guadiana.' }
  ];

  const historyItems = [
    'Nuestra historia en la industria forestal en la ciudad de Durango Durango, México, comenzó hace más de 50 años.',
    'Los fundadores de la empresa, la Familia Chaidez Reyes, encabezada por el Sr. Pedro Chaidez Varela, comenzaron a servir al mercado forestal.',
    'Desde 1995, nos dedicamos a la fabricación de molduras de madera de pino de calidad para exportación.',
    'Brindando un servicio de calidad en la producción de molduras de madera personalizadas.',
    'Trabajamos para embellecer tus proyectos de construcción.'
  ];

  return (
    <div className="w-full max-w-6xl mx-auto p-6 space-y-8 bg-gray-100">
      {/* Historia */}
      <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200">
        <h2 className="text-2xl font-bold text-emerald-700 mb-6">Nuestra Historia</h2>
        <div className="space-y-4">
          {historyItems.map((item, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-emerald-500" />
              <p className="text-gray-700 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Values Card */}
        <div className="bg-emerald-600 text-white rounded-xl shadow-lg p-6">
          <h2 className="text-2xl font-bold text-center mb-6">Valores</h2>
          <div className="space-y-4">
            {values.map((value, index) => (
              <div key={index} className="space-y-2">
                <h3 className="font-semibold text-[#FDF7F4]">{value.title}</h3> {/* Color de letra actualizado */}
                <p className="text-sm text-emerald-50 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mission Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
          <h2 className="text-2xl font-bold text-emerald-700 mb-6">Misión</h2>
          <p className="text-gray-700 leading-relaxed">
            Ser la empresa líder en la industria maderera que obtenga la mayor rentabilidad
            del sector a través de la exportación de productos y servicios de excelente calidad,
            optimizando recursos y alcanzando estándares internacionales. Garantizar que cada 
            actividad productiva se realice con absoluta seguridad para los empleados 
            e instalaciones. Crecer y expandirse respetando el medio ambiente, la comunidad, 
            y garantizando un desarrollo sostenible.
          </p>
        </div>

        {/* Purpose Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
          <h2 className="text-2xl font-bold text-emerald-700 mb-6">Propósito</h2>
          <p className="text-gray-700 leading-relaxed">
            Contribuir al bienestar de la comunidad ofreciendo oportunidades de empleo
            dentro de un marco de calidad técnica y humana, proporcionando un servicio integral
            que satisfaga las demandas del mercado promoviendo la conservación del medio ambiente.
          </p>
        </div>
      </div>

      {/* Quality Policy */}
      <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
        <h2 className="text-2xl font-bold text-emerald-700 mb-6">Política de Calidad</h2>
        <p className="text-gray-700 leading-relaxed">
          En Maderas Estufadas del Guadiana, estamos comprometidos con cumplir los requisitos de 
          calidad y servicio demandados por nuestros clientes en el sector de producción y 
          exportación forestal. Este compromiso está basado en los principios, valores y 
          capacidades técnicas de nuestro equipo, mejorando continuamente nuestros procesos de producción, 
          infraestructura y tecnología para lograr la satisfacción del cliente. Nuestro objetivo es crear 
          un entorno de trabajo seguro y saludable, cumpliendo con los requisitos legales aplicables.
        </p>
      </div>
    </div>
  );
};

export default CompanyInfoCards;
